import React from 'react';
import { IPlannedActivitiesTabPanel } from './interfaces';
import { TabPanel } from '../../../../../components/tabs';
import { ManagedDataTable } from '../../../../../components/ManagedDataTable';
import { useGetPlannedActivities } from '../../../../../reactQuery/Activities/activities';
import { IManagedDataTable } from '../../../../../components/ManagedDataTable/interfaces';
import { PlannedActivity } from '../../../../../api/activitiesApi/interfaces';
import { ROUTES } from '../../../../../routes/Routes';
import { useNavigate } from 'react-router';
import { DATA_TABLE_STORAGE_KEYS } from '../../../../../constants';
import {
  getColumns,
  getRowClassName,
} from '../../../../Activities/Overview/helpers';
import { getWarningRowStyling } from '../../../../../helpers/tableStyleHelper';

export const PlannedActivitiesTabPanel: React.FC<
  IPlannedActivitiesTabPanel
> = ({ value, index, clientId }): JSX.Element => {
  const navigate = useNavigate();
  const onRowClick = (row: PlannedActivity): void => {
    navigate(ROUTES.activities.details(row.id));
  };

  return (
    <TabPanel value={value} index={index}>
      <ManagedDataTable
        query={
          useGetPlannedActivities as IManagedDataTable<PlannedActivity>['query']
        }
        columns={getColumns(true)}
        onRowClick={onRowClick}
        storageKey={DATA_TABLE_STORAGE_KEYS.clientPlannedActivities}
        initialSort={{ field: 'performAt', sort: 'desc' }}
        filter={[
          {
            field: 'client',
            operator: '=',
            value: clientId,
          },
        ]}
        getRowClassName={getRowClassName}
        sx={getWarningRowStyling()}
      />
    </TabPanel>
  );
};
